import { useEffect, useState } from "react";

interface ThemeLogoProps {
  className?: string;
  alt?: string;
  /** Use "onGradient" when placed over gradient-primary (red) backgrounds */
  variant?: "auto" | "onGradient";
}

export default function ThemeLogo({ className = "h-12 w-auto", alt = "Submission BJJ Red Line", variant = "auto" }: ThemeLogoProps) {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const check = () => setIsDark(document.documentElement.classList.contains("dark"));
    check();
    const observer = new MutationObserver(check);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    return () => observer.disconnect();
  }, []);

  const src = variant === "onGradient" ? "/logo-dark.png" : (isDark ? "/logo-dark.png" : "/logo-light.png");

  return (
    <img
      src={src}
      alt={alt}
      className={`${className} drop-shadow-[0_4px_16px_rgba(0,0,0,0.3)]`}
      loading="eager"
      fetchPriority="high"
      width={160}
      height={160}
    />
  );
}
